

function _createModal(options: any) {
  const DEFAULT_WIDTH = '600px'
  const modal = document.createElement('div')
  modal.classList.add('modal')
  modal.insertAdjacentHTML('afterbegin', `
    <div class="modal-overlay" data-close="true"></div>
    <div class="modal-window">
      <div class="modal-container" style="max-width: ${options.width || DEFAULT_WIDTH}">
        <button class="close-modal-btn" data-close="true"></button>
        <div class="modal-body" data-content>${options.content || ''}</div>
      </div>
    </div>
  `)
  document.body.appendChild(modal)
  return modal
}

export function Modal (options: any) {
  const ANIMATION_SPEED = 200
  const $modal = _createModal(options)
  const content = $modal.querySelector('[data-content]')

  let closing = false
  let destroyed = false

  const modal = {
    open() {
      if (destroyed) {
        return console.log('Modal is destroyed')
      }
      !closing && $modal.classList.add('open')
    },
    close() {
      closing = true
      $modal.classList.remove('open')
      $modal.classList.add('hide')
      setTimeout(() => {
        $modal.classList.remove('hide')
        closing = false
      }, ANIMATION_SPEED)
    }
  }

  const listener = event => {
    if (event.target.classList.contains('modal-overlay') || event.target.classList.contains('modal-window')) {
      return modal.close();
    }

    if (event.target.dataset.close) {
      modal.close()
    }
  }

  $modal.addEventListener('click', listener)

  return Object.assign(modal, {
    destroy() {
      $modal.parentNode?.removeChild($modal)
      $modal.removeEventListener('click', listener)
      destroyed = true
    },
    setContent(html: string) {
      if(content) content.innerHTML = html
    },
    getContentElement() {
      return content
    }
  })
}